// Utils
import { getMany } from '../../../common/utils/immutableHelper';
import { createSmartSelector } from '../../utils/milanoteReselect/milanoteReselect';
import { isContent, isBoardLike } from '../../../common/elements/utils/elementTypeUtils';
import { getPhysicalId } from '../../../common/elements/utils/elementPropertyUtils';

// Selectors
import { boardVisibleElementGraphSelector, elementGraphSelector } from '../selectors/elementGraphSelector';
import { getElement as getElementFromProps, getElements } from '../selectors/elementSelector';
import { getChildType } from './containerElementUtil';

const getVisibleChildrenIdsSelector = () =>
    createSmartSelector(
        getElementFromProps,
        elementGraphSelector,
        boardVisibleElementGraphSelector,
        (element, elementGraph, boardVisibleElementGraph) => {
            const elementId = getPhysicalId(element);

            const visibleChildren = isBoardLike(element)
                ? boardVisibleElementGraph[elementId]
                : elementGraph[elementId];

            return visibleChildren || [];
        },
    );

const getVisibleChildrenSelector = () => createSmartSelector(getVisibleChildrenIdsSelector(), getElements, getMany);

export const makeContainerElementChildrenTypesSelector = () =>
    createSmartSelector(getVisibleChildrenSelector(), (children) =>
        children.reduce((acc, child) => {
            if (!(isContent(child) || isBoardLike(child))) return acc;

            const type = getChildType(child);
            const typeVal = acc[type];
            acc[type] = typeVal ? typeVal + 1 : 1;
            return acc;
        }, {}),
    );
